import { useState, useEffect } from "react";
import {
  FaPlus,
  FaTimes,
  FaUniversity,
  FaCreditCard,
  FaEdit,
  FaChartLine,
  FaCheckCircle,
  FaTag,
  FaGlobe,
  FaShieldAlt,
  FaArrowRight,
  FaUpload,
  FaStar,
  FaUserTie,
} from "react-icons/fa";
import CredirCardDetails from "./CreditCardDetails";
import { useApi } from "../context/useApi";

const CreditCardPanel = () => {
  const [expandedBanks, setExpandedBanks] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [isFetchingBanks, setIsFetchingBanks] = useState(true);
  const [editingBankId, setEditingBankId] = useState(null);
  const [modalMode, setModalMode] = useState("addBank");
  const [tagInput, setTagInput] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [step, setStep] = useState(1); 
  const [rewards, setRewards] = useState([]);
    const { apiFetch } = useApi();
  const [accRewards, setAccRewards] = useState([]);
  const [rewardInput, setRewardInput] = useState({
    reward_type: "",
    reward_rate: "",
    spending_amount: "",
  });
  const [accRewardInput, setAccRewardInput] = useState({
    vendor: "",
    multiplier: "",
  });

  const [newCard, setNewCard] = useState({
    card_name: "",
    card_image_url: "",
    issuing_bank: "",
    bank_id: "",
    card_network: "VISA",
    website_link: "",
    lifetime_free: "No",
    card_type: "Travel",
    tags: [],
  });

  const [newBank, setNewBank] = useState({
    name: "",
    logo_url: "",
    institution_type: "Bank",
    ownership_type: "Private",
    regulatory_body: "",
    head_office_address: "",
    branch_count: "",
    services_offered: "",
    is_active: false,
    is_listed: false,
    bank_admin_id: "",
    subscription_plan: "Free",
    bank_registration_number: "",
  });

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };
  const API_BASE = "https://admin-backend-fbuuh6fo3q-el.a.run.app/banks";

  useEffect(() => {
    const fetchBanksWithCards = async () => {
      setIsFetchingBanks(true);
      try {
        const response = await apiFetch(`${API_BASE}/banks/cards`);
        if (!response) return;
        const data = await response.json();
        if (response.ok) {
          setBanks(data.banks || []);
        } else {
          showToast(data.error || "Failed to fetch banks", "error");
        }
      } catch (err) {
        console.error(err);
        showToast("Something went wrong while fetching banks", "error");
      } finally {
        setIsFetchingBanks(false);
      }
    };

    fetchBanksWithCards();
  }, [apiFetch]);

  const toggleExpand = (bankId) => {
    setExpandedBanks((prev) => ({
      ...prev,
      [bankId]: !prev[bankId],
    }));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewBank((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setNewBank((prev) => ({
          ...prev,
          logo_url: reader.result,
        }));
      };

      reader.readAsDataURL(file);
    }
  };
  const handleCardLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewCard((prev) => ({
          ...prev,
          card_image_url: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddBank = async () => {
    if (
      !newBank.name ||
      !newBank.institution_type ||
      !newBank.ownership_type ||
      !newBank.regulatory_body ||
      !newBank.head_office_address ||
      !newBank.logo_url ||
      !newBank.bank_registration_number
    ) {
      showToast("Please fill all mandatory fields (*)", "error");
      return;
    }

    if (!newBank.is_active || !newBank.is_listed) {
      showToast("Please confirm the bank is Active and Listed", "error");
      return;
    }
    setIsLoading(true);
    try {
      const response = await apiFetch(`${API_BASE}/add-bank`, {
        method: "POST",
        body: JSON.stringify(newBank),
      });
if (!response) return;
      const data = await response.json();

      if (response.ok) {
        showToast(data.message || "Bank added successfully!", "success");
        setIsModalOpen(false);
        const refreshed = await apiFetch(`${API_BASE}/banks/cards`);
        const refreshedData = await refreshed.json();
        setBanks(refreshedData.banks || []);
        setNewBank({
          name: "",
          logo_url: "",
          institution_type: "Bank",
          ownership_type: "Private",
          regulatory_body: "",
          head_office_address: "",
          branch_count: "",
          services_offered: "",
          is_active: false,
          is_listed: false,
          bank_admin_id: "",
          subscription_plan: "Free",
          bank_registration_number: "",
        });
      } else {
        showToast(data.error || "Failed to add bank", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong! Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  const handleEditBank = async (bankId, updatedBank) => {
    setIsLoading(true);
    try {
      const response = await apiFetch(`${API_BASE}/update-bank/${bankId}`, {
        method: "PUT",
        body: JSON.stringify(updatedBank),
      });
if (!response) return;
      const data = await response.json();

      if (response.ok) {
        showToast(data.message || "Bank updated successfully!", "success");
        const refreshed = await apiFetch(`${API_BASE}/banks/cards`);
        const refreshedData = await refreshed.json();
        setBanks(refreshedData.banks || []);

        setIsModalOpen(false);
        setEditingBankId(null);
        setNewBank({
          name: "",
          logo_url: "",
          institution_type: "Bank",
          ownership_type: "Private",
          regulatory_body: "",
          head_office_address: "",
          branch_count: "",
          services_offered: "",
          is_active: false,
          is_listed: false,
          bank_admin_id: "",
          subscription_plan: "Free",
          bank_registration_number: "",
        });
      } else {
        showToast(data.error || "Failed to update bank", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Something went wrong! Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
const handleAddCardFull = async () => {
  if (
    !newCard.card_name ||
    !newCard.card_image_url ||
    !newCard.card_network ||
    !newCard.website_link ||
    !newCard.card_type
  ) {
    showToast("Please fill all mandatory fields (*)", "error");
    return;
  }

  setIsLoading(true);
  try {
    const payload = { ...newCard, rewards, accelerated_rewards: accRewards };

    const response = await apiFetch(`${API_BASE}/cards/add-card`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
if (!response) return;
    const data = await response.json();

    if (response.ok) {
      showToast("Card & rewards added successfully!", "success");
      const refreshed = await apiFetch(`${API_BASE}/banks/cards`);
      const refreshedData = await refreshed.json();
      setBanks(refreshedData.banks || []);
      closeModal();
    } else {
      showToast(data.error || "Failed to add card", "error");
    }
  } catch (err) {
    console.error(err);
    showToast("Something went wrong!", "error");
  } finally {
    setIsLoading(false);
  }
};

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingBankId(null);
    setNewBank({
      name: "",
      logo_url: "",
      institution_type: "Bank",
      ownership_type: "Private",
      regulatory_body: "",
      head_office_address: "",
      branch_count: "",
      services_offered: "",
      is_active: false,
      is_listed: false,
      bank_admin_id: "",
      subscription_plan: "Free",
      bank_registration_number: "",
    });

    setNewCard({
      card_name: "",
      card_image_url: "",
      card_network: "VISA",
      website_link: "",
      card_type: "Travel",
      issuing_bank: "",
      lifetime_free: "No",
      bank_id: "",
      tags: [],
    });
    setTagInput("");
  };

  return (
    <>
      {!selectedCard ? (
        <>
          {" "}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-10">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800">
                Credit Cards
              </h2>
              <p className="text-sm text-gray-500">
                Manage banks, institutions, and their associated credit card
                details.
              </p>
            </div>

            <button
              onClick={() => {
                setModalMode("addBank");
                setEditingBankId(null);
                setNewBank({
                  name: "",
                  logo_url: "",
                  institution_type: "Bank",
                  ownership_type: "Private",
                  regulatory_body: "",
                  head_office_address: "",
                  branch_count: "",
                  services_offered: "",
                  is_active: false,
                  is_listed: false,
                  bank_admin_id: "",
                  subscription_plan: "Free",
                  bank_registration_number: "",
                });
                setIsModalOpen(true);
              }}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white border bg-gray-900 rounded-lg hover:bg-gray-800"
            >
              <FaPlus />
              Add Bank
            </button>
          </div>
          <div className="space-y-8">
            {isFetchingBanks ? (
              <>
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="border-2 border-gray-200 rounded-xl p-5 animate-pulse"
                  >
                    {/* Brand Header */}
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 border-2 border-gray-300 rounded-lg"></div>
                        <div className="h-5 w-32 border border-gray-300 rounded"></div>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                        <div className="h-9 w-32 border border-gray-300 rounded-lg"></div>
                        <div className="h-9 w-28 border border-gray-300 rounded-lg"></div>
                      </div>
                    </div>

                    {/* Product Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                      {[1, 2, 3].map((j) => (
                        <div
                          key={j}
                          className="flex flex-col items-center border border-gray-200 rounded-lg p-4"
                        >
                          <div className="w-40 h-28 border border-gray-300 rounded-lg mb-3"></div>
                          <div className="h-4 w-24 border border-gray-300 rounded"></div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              banks.map((bank) => {
                const isExpanded = expandedBanks[bank.bank_id];
                const visibleCards = isExpanded
                  ? bank.cards
                  : (bank.cards || []).slice(0, 3);

                return (
                  <div
                    key={bank.bank_id}
                    className="border rounded-xl shadow-md p-5 bg-white"
                  >
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 gap-4">
                      <div className="flex items-center gap-3">
                        <img
                          src={bank.logo_url}
                          alt={`${bank.name} logo`}
                          className="w-10 h-10 object-contain rounded-lg"
                        />
                        <h4 className="text-lg font-semibold">{bank.name}</h4>
                      </div>

                      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                        <button
                          onClick={() => {
                            setModalMode("addCard");
                            setNewCard({
                              ...newCard,
                              issuing_bank: bank.name,
                              bank_id: bank.bank_id,
                            });
                            setIsModalOpen(true);
                          }}
                          className="px-3 py-1.5 text-sm sm:text-base rounded-lg flex items-center justify-center gap-2  text-white border bg-gray-900  hover:bg-gray-800"
                        >
                          <FaPlus /> Add Credit Card
                        </button>

                        <button
                          onClick={() => {
                            setModalMode("editBank");
                            setNewBank(bank);
                            setIsModalOpen(true);
                            setEditingBankId(bank.bank_id);
                          }}
                          className="px-3 py-1.5 text-sm sm:text-base rounded-lg flex items-center justify-center gap-2 border border-black text-blue-600 hover:bg-blue-50 transition"
                        >
                          Edit Bank
                        </button>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
                      {visibleCards.map((card) => (
                        <div
                          key={card.card_id}
                          className="flex flex-col items-center border rounded-lg p-3 sm:p-4 hover:shadow-md transition cursor-pointer"
                          onClick={() => setSelectedCard(card)}
                        >
                          <div className="w-32 sm:w-40 h-20 sm:h-28 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center mb-3">
                            <img
                              src={card.image}
                              alt={card.name}
                              className="w-full h-full object-contain rounded-lg"
                            />
                          </div>
                          <h5 className="font-medium text-center text-sm sm:text-base">
                            {card.name}
                          </h5>
                        </div>
                      ))}
                    </div>

                    {bank.cards && bank.cards.length > 3 && (
                      <div className="flex justify-center mt-4">
                        <button
                          onClick={() => toggleExpand(bank.bank_id)}
                          className="px-4 py-2 text-blue-600 hover:underline"
                        >
                          {isExpanded ? "Show Less" : "View All"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </>
      ) : (
        <CredirCardDetails
          card={selectedCard}
          goBack={() => setSelectedCard(null)}
        />
      )}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                {modalMode === "addBank" && (
                  <>
                    <FaUniversity className="text-blue-600" />
                    Add New Bank
                  </>
                )}
                {modalMode === "editBank" && (
                  <>
                    <FaEdit className="text-blue-600" />
                    Edit Bank
                  </>
                )}
                {modalMode === "addCard" && (
                  <>
                    <FaCreditCard className="text-green-600" />
                    Add Credit Card
                  </>
                )}
              </h3>
              <button
                onClick={closeModal}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FaTimes className="text-gray-500" />
              </button>
            </div>

            <div className="p-6">
              {modalMode === "addCard" ? (
                step === 1 ? (
                  <div className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Card Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="card_name"
                          value={newCard.card_name}
                          onChange={(e) =>
                            setNewCard({
                              ...newCard,
                              card_name: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                          placeholder="e.g., Platinum Rewards Card"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Card Network <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="card_network"
                          value={newCard.card_network}
                          onChange={(e) =>
                            setNewCard({
                              ...newCard,
                              card_network: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        >
                          <option value="VISA">VISA</option>
                          <option value="Mastercard">Mastercard</option>
                          <option value="Amex">American Express</option>
                          <option value="RuPay">RuPay</option>
                          <option value="Diners Club">Diners Club</option>
                          <option value="Discover">Discover</option>
                          <option value="UnionPay">UnionPay</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Card Type <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="card_type"
                          value={newCard.card_type}
                          onChange={(e) =>
                            setNewCard({
                              ...newCard,
                              card_type: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        >
                          <option value="Travel">Travel</option>
                          <option value="Rewards">Rewards</option>
                          <option value="Fuel">Fuel</option>
                          <option value="Cashback">Cashback</option>
                          <option value="Lifestyle">Lifestyle</option>
                          <option value="Business">Business</option>
                          <option value="Student">Student</option>
                          <option value="Premium">Premium</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Lifetime Free <span className="text-red-500">*</span>
                        </label>
                        <select
                          name="lifetime_free"
                          value={newCard.lifetime_free}
                          onChange={(e) =>
                            setNewCard({
                              ...newCard,
                              lifetime_free: e.target.value,
                            })
                          }
                          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Website Link <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <FaGlobe className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                          <input
                            type="url"
                            name="website_link"
                            value={newCard.website_link}
                            onChange={(e) =>
                              setNewCard({
                                ...newCard,
                                website_link: e.target.value,
                              })
                            }
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                            placeholder="https://example.com/card-details"
                          />
                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Card Image <span className="text-red-500">*</span>
                        </label>
                        <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleCardLogoUpload}
                            className="hidden"
                            id="card-image-upload"
                          />
                          <label
                            htmlFor="card-image-upload"
                            className="cursor-pointer flex flex-col items-center"
                          >
                            {newCard.card_image_url ? (
                              <img
                                src={newCard.card_image_url}
                                alt="Card Preview"
                                className="h-32 object-contain rounded-lg"
                              />
                            ) : (
                              <>
                                <FaUpload className="text-3xl text-gray-400 mb-2" />
                                <span className="text-sm text-gray-600">
                                  Click to upload card image
                                </span>
                              </>
                            )}
                          </label>
                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                          Tags
                        </label>
                        <div className="flex gap-2">
                          <div className="relative flex-1">
                            <FaTag className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                            <input
                              type="text"
                              value={tagInput}
                              onChange={(e) => setTagInput(e.target.value)}
                              onKeyPress={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  if (
                                    tagInput.trim() &&
                                    !newCard.tags.includes(tagInput.trim())
                                  ) {
                                    setNewCard({
                                      ...newCard,
                                      tags: [...newCard.tags, tagInput.trim()],
                                    });
                                    setTagInput("");
                                  }
                                }
                              }}
                              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                              placeholder="Type a tag and press Enter"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              if (
                                tagInput.trim() &&
                                !newCard.tags.includes(tagInput.trim())
                              ) {
                                setNewCard({
                                  ...newCard,
                                  tags: [...newCard.tags, tagInput.trim()],
                                });
                                setTagInput("");
                              }
                            }}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                          >
                            Add Tag
                          </button>
                        </div>
                        {newCard.tags.length > 0 && (
                          <div className="flex flex-wrap gap-2 mt-3">
                            {newCard.tags.map((tag, idx) => (
                              <span
                                key={idx}
                                className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800"
                              >
                                {tag}
                                <button
                                  type="button"
                                  onClick={() =>
                                    setNewCard({
                                      ...newCard,
                                      tags: newCard.tags.filter(
                                        (t) => t !== tag
                                      ),
                                    })
                                  }
                                  className="ml-2 text-blue-600 hover:text-blue-800"
                                >
                                  <FaTimes className="text-xs" />
                                </button>
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="flex justify-between pt-6 border-t">
                      <button
                        onClick={closeModal}
                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => setStep(2)}
                        className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-500 transition-colors flex items-center gap-2"
                      >
                        Next: Add Rewards
                        <FaArrowRight />
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-6">
                    <div className="bg-blue-50 rounded-lg p-4 mb-6">
                      <h4 className="font-semibold text-blue-900 mb-2">
                        Step 2 of 2: Configure Rewards
                      </h4>
                      <p className="text-sm text-blue-700">
                        Add reward details for {newCard.card_name}
                      </p>
                    </div>

                    {/* Standard Rewards */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <FaChartLine className="text-green-600" />
                        Standard Rewards
                      </h4>

                      <div className="grid grid-cols-3 gap-3 mb-4">
                        <select
                          value={rewardInput.reward_type}
                          onChange={(e) =>
                            setRewardInput({
                              ...rewardInput,
                              reward_type: e.target.value,
                            })
                          }
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 "
                        >
                          <option value="">Select Type</option>
                          <option value="Points">Points</option>
                          <option value="Miles">Miles</option>
                          <option value="Cashback">Cashback</option>
                        </select>
                        <input
                          type="number"
                          placeholder="Rate (e.g., 2)"
                          value={rewardInput.reward_rate}
                          onChange={(e) =>
                            setRewardInput({
                              ...rewardInput,
                              reward_rate: e.target.value,
                            })
                          }
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 "
                        />
                        <div className="flex gap-2">
                          <input
                            type="number"
                            placeholder="Per ₹"
                            value={rewardInput.spending_amount}
                            onChange={(e) =>
                              setRewardInput({
                                ...rewardInput,
                                spending_amount: e.target.value,
                              })
                            }
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 "
                          />
                          <button
                            type="button"
                            onClick={() => {
                              if (
                                rewardInput.reward_type &&
                                rewardInput.reward_rate &&
                                rewardInput.spending_amount
                              ) {
                                setRewards([...rewards, rewardInput]);
                                setRewardInput({
                                  reward_type: "",
                                  reward_rate: "",
                                  spending_amount: "",
                                });
                              }
                            }}
                            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      {rewards.length > 0 && (
                        <div className="space-y-2">
                          {rewards.map((r, idx) => (
                            <div
                              key={idx}
                              className="flex items-center justify-between bg-white rounded-lg px-4 py-2"
                            >
                              <span className="text-sm text-gray-700">
                                <span className="font-semibold">
                                  {r.reward_type}:
                                </span>{" "}
                                {r.reward_rate} per ₹{r.spending_amount}
                              </span>
                              <button
                                onClick={() =>
                                  setRewards(
                                    rewards.filter((_, i) => i !== idx)
                                  )
                                }
                                className="text-red-500 hover:text-red-700"
                              >
                                <FaTimes />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Accelerated Rewards */}
                    <div className="bg-gray-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <FaStar className="text-yellow-600" />
                        Accelerated Rewards
                      </h4>

                      <div className="grid grid-cols-2 gap-3 mb-4">
                        <input
                          type="text"
                          placeholder="Vendor/Category"
                          value={accRewardInput.vendor}
                          onChange={(e) =>
                            setAccRewardInput({
                              ...accRewardInput,
                              vendor: e.target.value,
                            })
                          }
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 "
                        />
                        <div className="flex gap-2">
                          <input
                            type="number"
                            placeholder="Multiplier (e.g., 5)"
                            value={accRewardInput.multiplier}
                            onChange={(e) =>
                              setAccRewardInput({
                                ...accRewardInput,
                                multiplier: e.target.value,
                              })
                            }
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 "
                          />
                          <button
                            type="button"
                            onClick={() => {
                              if (
                                accRewardInput.vendor &&
                                accRewardInput.multiplier
                              ) {
                                setAccRewards([...accRewards, accRewardInput]);
                                setAccRewardInput({
                                  vendor: "",
                                  multiplier: "",
                                });
                              }
                            }}
                            className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 transition-colors"
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      {accRewards.length > 0 && (
                        <div className="space-y-2">
                          {accRewards.map((a, idx) => (
                            <div
                              key={idx}
                              className="flex items-center justify-between bg-white rounded-lg px-4 py-2"
                            >
                              <span className="text-sm text-gray-700">
                                <span className="font-semibold">
                                  {a.vendor}:
                                </span>{" "}
                                {a.multiplier}x rewards
                              </span>
                              <button
                                onClick={() =>
                                  setAccRewards(
                                    accRewards.filter((_, i) => i !== idx)
                                  )
                                }
                                className="text-red-500 hover:text-red-700"
                              >
                                <FaTimes />
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div className="flex justify-between pt-6 border-t">
                      <button
                        onClick={() => setStep(1)}
                        className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        Back
                      </button>
                      <button
                        onClick={handleAddCardFull}
                        disabled={isLoading}
                        className={`px-6 py-2 rounded-lg text-white flex items-center gap-2 ${
                          isLoading
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-black hover:bg-gray-200"
                        } transition-colors`}
                      >
                        {isLoading ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            Saving...
                          </>
                        ) : (
                          <>
                            <FaCheckCircle />
                            Save Card & Rewards
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )
              ) : (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Bank Form Fields */}
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Bank Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={newBank.name}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="Enter bank name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Institution Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="institution_type"
                        value={newBank.institution_type}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                      >
                        <option value="Bank">Bank</option>
                        <option value="NBFC">NBFC</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Ownership Type <span className="text-red-500">*</span>
                      </label>
                      <select
                        name="ownership_type"
                        value={newBank.ownership_type}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                      >
                        <option value="Private">Private</option>
                        <option value="Government">Government</option>
                        <option value="Foreign">Foreign</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Regulatory Body <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="regulatory_body"
                        value={newBank.regulatory_body}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="e.g., RBI"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Branch Count
                      </label>
                      <input
                        type="number"
                        name="branch_count"
                        value={newBank.branch_count}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="Number of branches"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Registration Number{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="bank_registration_number"
                        value={newBank.bank_registration_number}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="Registration number"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Subscription Plan
                      </label>
                      <select
                        name="subscription_plan"
                        value={newBank.subscription_plan}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                      >
                        <option value="Free">Free</option>
                        <option value="Standard">Standard</option>
                        <option value="Premium">Premium</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        <FaUserTie className="inline mr-1" />
                        Bank Admin ID
                      </label>
                      <input
                        type="text"
                        name="bank_admin_id"
                        value={newBank.bank_admin_id}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="Admin mobile number"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Head Office Address{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        name="head_office_address"
                        value={newBank.head_office_address}
                        onChange={handleInputChange}
                        rows="3"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="Complete address"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Services Offered
                      </label>
                      <input
                        type="text"
                        name="services_offered"
                        value={newBank.services_offered}
                        onChange={handleInputChange}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent transition-all"
                        placeholder="e.g., Loans, Deposits, Credit Cards"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Bank Logo <span className="text-red-500">*</span>
                      </label>
                      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-blue-400 transition-colors">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleLogoUpload}
                          className="hidden"
                          id="bank-logo-upload"
                        />
                        <label
                          htmlFor="bank-logo-upload"
                          className="cursor-pointer flex flex-col items-center"
                        >
                          {newBank.logo_url ? (
                            <img
                              src={newBank.logo_url}
                              alt="Logo Preview"
                              className="h-24 w-24 object-contain rounded-lg"
                            />
                          ) : (
                            <>
                              <FaUpload className="text-3xl text-gray-400 mb-2" />
                              <span className="text-sm text-gray-600">
                                Click to upload bank logo
                              </span>
                            </>
                          )}
                        </label>
                      </div>
                    </div>

                    <div className="md:col-span-2">
                      <div className="flex items-center gap-6 p-4 bg-gray-50 rounded-lg">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            name="is_active"
                            checked={newBank.is_active}
                            onChange={handleInputChange}
                            className="w-5 h-5 text-blue-600 rounded "
                          />
                          <span className="font-medium text-gray-700">
                            <FaCheckCircle className="inline mr-1 text-green-600" />
                            Active Bank
                          </span>
                        </label>

                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            name="is_listed"
                            checked={newBank.is_listed}
                            onChange={handleInputChange}
                            className="w-5 h-5 text-blue-600 rounded "
                          />
                          <span className="font-medium text-gray-700">
                            <FaShieldAlt className="inline mr-1 text-blue-600" />
                            Listed on Stock Exchange
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between pt-6 border-t">
                    <button
                      onClick={closeModal}
                      className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={
                        modalMode === "editBank"
                          ? () => handleEditBank(editingBankId, newBank)
                          : handleAddBank
                      }
                      disabled={isLoading}
                      className={`px-6 py-2 rounded-lg text-white flex items-center gap-2 ${
                        isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-black hover:bg-gray-200"
                      } transition-colors`}
                    >
                      {isLoading ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          {modalMode === "editBank"
                            ? "Updating..."
                            : "Saving..."}
                        </>
                      ) : (
                        <>
                          <FaCheckCircle />
                          {modalMode === "editBank"
                            ? "Update Bank"
                            : "Add Bank"}
                        </>
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {toast.message && (
        <div
          className={`fixed top-5 right-5 px-4 py-2 rounded shadow-lg text-white z-50 transition ${
            toast.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {toast.message}
        </div>
      )}
    </>
  );
};

export default CreditCardPanel;
